/**
 * Gordonix arama — storefront'u Admin/Suggest kalitesine yaklaştırır
 *
 * 1) Marka araması (ORNARTO, Skinarma) → vendor: eşlemesi
 * 2) Model/ölçü (45mm, Watch 7) → kritik parçalar zorunlu
 * 3) /search sayfası: gevşek Shopify sonuçlarını suggest ile filtrele/doldur
 * 4) Predictive: yanlış ölçü/model kartlarını gizle
 */
(function () {
  var STOP = {
    ve: 1,
    icin: 1,
    için: 1,
    ile: 1,
    the: 1,
    and: 1,
    for: 1,
    with: 1,
    uyumlu: 1,
    seri: 1,
    serisi: 1,
    model: 1,
    renk: 1,
    kapak: 1,
    kilif: 1,
    kılıf: 1,
    strap: 1,
    kayis: 1,
    kayış: 1,
  };

  function norm(s) {
    return String(s || "")
      .toLocaleLowerCase("tr-TR")
      .replace(/ı/g, "i")
      .replace(/İ/g, "i")
      .replace(/\u0307/g, "")
      .replace(/['’]/g, "")
      .trim();
  }

  function tokenize(q) {
    // Barkod / ürün no araması: Shopify sonucu olduğu gibi kalsın
    if (/^\d{8,}$/.test(String(q || "").replace(/[\s-]/g, ""))) return [];
    var raw = norm(q).replace(/vendor:\s*/i, "");
    raw = raw.replace(/(\d+(?:[.,]\d+)?)\s*mm\b/g, "$1mm");
    raw = raw.replace(/(\d+(?:[.,]\d+)?)\s*inch\b/g, "$1inch");
    return raw
      .split(/[^a-z0-9.]+/i)
      .filter(Boolean)
      .filter(function (p) {
        if (STOP[p]) return false;
        if (p.length < 2 && !/^\d/.test(p)) return false;
        return true;
      });
  }

  function criticalTokens(tokens) {
    return tokens.filter(function (t) {
      return /\d/.test(t);
    });
  }

  function haystackOf(p) {
    return norm(
      [p.title, p.vendor, p.product_type, p.handle, (p.tags || []).join(" ")].join(
        " "
      )
    ).replace(/(\d+(?:[.,]\d+)?)\s*mm\b/g, "$1mm");
  }

  function productMatchesQuery(p, q) {
    var tokens = tokenize(q);
    if (!tokens.length) return true;
    var hay = haystackOf(p);
    var crit = criticalTokens(tokens);
    for (var i = 0; i < crit.length; i++) {
      if (hay.indexOf(crit[i]) === -1) return false;
    }
    var soft = tokens.filter(function (t) {
      return crit.indexOf(t) === -1;
    });
    if (!soft.length) return true;
    var hit = 0;
    soft.forEach(function (t) {
      if (hay.indexOf(t) !== -1) hit++;
    });
    return hit / soft.length >= 0.7;
  }

  function filterProducts(products, q) {
    return (products || []).filter(function (p) {
      return productMatchesQuery(p, q);
    });
  }

  function fetchSuggest(q) {
    return fetch(
      "/search/suggest.json?q=" +
        encodeURIComponent(q) +
        "&resources[type]=product&resources[limit]=50&resources[options][fields]=title,product_type,variants.title,variants.sku,variants.barcode,vendor,tag",
      { credentials: "same-origin", headers: { Accept: "application/json" } }
    )
      .then(function (r) {
        return r.json();
      })
      .then(function (data) {
        var list =
          (data &&
            data.resources &&
            data.resources.results &&
            data.resources.results.products) ||
          [];
        return filterProducts(list, q);
      });
  }

  function uniqueVendors(products) {
    var set = {};
    (products || []).forEach(function (p) {
      if (p && p.vendor) set[p.vendor] = true;
    });
    return Object.keys(set);
  }

  function isBrandOnlyQuery(q) {
    if (/\d/.test(q)) return false;
    if (/mm\b/i.test(q)) return false;
    var parts = norm(q).split(/\s+/).filter(Boolean);
    return parts.length > 0 && parts.length <= 2;
  }

  function shouldUseVendorSearch(q, products) {
    if (!isBrandOnlyQuery(q) || !products.length) return null;
    var vendors = uniqueVendors(products);
    if (vendors.length !== 1) return null;
    var vendor = vendors[0];
    var qn = norm(q);
    var vn = norm(vendor);
    if (qn === vn || vn.indexOf(qn) !== -1 || qn.indexOf(vn) !== -1) return vendor;
    return null;
  }

  function getQueryFromLocation() {
    return (new URLSearchParams(window.location.search).get("q") || "").trim();
  }

  function textOfCard(el) {
    return norm(el.textContent || el.getAttribute("aria-label") || "").replace(
      /(\d+(?:[.,]\d+)?)\s*mm\b/g,
      "$1mm"
    );
  }

  function cardMatchesQuery(card, q) {
    var tokens = tokenize(q);
    if (!tokens.length) return true;
    var hay = textOfCard(card);
    var crit = criticalTokens(tokens);
    for (var i = 0; i < crit.length; i++) {
      if (hay.indexOf(crit[i]) === -1) return false;
    }
    var soft = tokens.filter(function (t) {
      return crit.indexOf(t) === -1;
    });
    if (!soft.length) return true;
    var hit = 0;
    soft.forEach(function (t) {
      if (hay.indexOf(t) !== -1) hit++;
    });
    return hit / soft.length >= 0.7;
  }

  function filterDomCards(container, q, allowedIds) {
    if (!container) return { kept: 0, total: 0 };
    var cards = container.querySelectorAll(
      "li.product-grid__item, li.predictive-search-results__card--product, .resource-list__item, product-card"
    );
    if (!cards.length) {
      cards = container.querySelectorAll("[data-product-id]");
    }
    var kept = 0;
    var total = 0;
    cards.forEach(function (card) {
      var row =
        card.closest("li") ||
        card.closest(".resource-list__item") ||
        card.closest(".predictive-search-results__card") ||
        card;
      if (!row || row.getAttribute("data-gordonix-suggest-item") === "1") return;
      total++;
      var id = String(
        row.getAttribute("data-product-id") ||
          (row.querySelector("[data-product-id]") &&
            row.querySelector("[data-product-id]").getAttribute("data-product-id")) ||
          ""
      ).replace("gid://shopify/Product/", "");
      var ok = cardMatchesQuery(row, q);
      if (ok && allowedIds && allowedIds.size) {
        ok = !id || allowedIds.has(id);
      }
      row.style.display = ok ? "" : "none";
      row.hidden = !ok;
      if (!ok) row.setAttribute("data-gordonix-filtered", "1");
      else {
        row.removeAttribute("data-gordonix-filtered");
        kept++;
      }
    });
    return { kept: kept, total: total };
  }

  function productId(p) {
    return String(p.id || "").replace("gid://shopify/Product/", "");
  }

  function appendSuggestCards(target, products, have) {
    products.forEach(function (p) {
      var id = productId(p);
      if (!id || have.has(id)) return;
      have.add(id);
      var url = p.url || "/products/" + (p.handle || "");
      var img =
        (p.image && (p.image.url || p.image)) ||
        (p.featured_image && (p.featured_image.url || p.featured_image)) ||
        "";
      var li = document.createElement("li");
      li.className = "product-grid__item gordonix-search-suggest-item";
      li.setAttribute("data-product-id", id);
      li.setAttribute("data-gordonix-suggest-item", "1");
      li.innerHTML =
        '<product-card class="product-card" data-product-id="' +
        id +
        '"><a class="product-card__link" href="' +
        url +
        '">' +
        (img
          ? '<img src="' +
            String(img).replace(/"/g, "&quot;") +
            '" alt="" loading="lazy" width="400" height="400" style="width:100%;height:auto;aspect-ratio:1/1;object-fit:cover;" />'
          : "") +
        '<h3 class="product-card__title" style="margin:0.5rem 0 0.25rem;font-size:0.95rem;">' +
        (p.title || "") +
        "</h3></a></product-card>";
      target.appendChild(li);
    });
  }

  function watchPredictive() {
    var root =
      document.querySelector("predictive-search-component") ||
      document.querySelector("predictive-search") ||
      document.querySelector("[data-testid='search-component--modal']") ||
      document.querySelector("search-modal") ||
      document.body;

    function currentInputQuery() {
      var input =
        document.querySelector('predictive-search-component input[name="q"]') ||
        document.querySelector('predictive-search input[name="q"]') ||
        document.querySelector('search-modal input[name="q"]') ||
        document.querySelector('input[type="search"][name="q"]') ||
        document.querySelector('input[name="q"]');
      return input ? String(input.value || "").trim() : "";
    }

    var timer = null;
    function apply() {
      var q = currentInputQuery();
      if (!q) return;
      var box =
        document.querySelector("#predictive-search-results") ||
        document.querySelector(".predictive-search-dropdown") ||
        document.querySelector("predictive-search-component") ||
        root;
      filterDomCards(box, q, null);
    }

    var mo = new MutationObserver(function () {
      clearTimeout(timer);
      timer = setTimeout(apply, 60);
    });
    mo.observe(document.documentElement, { childList: true, subtree: true });
    document.addEventListener(
      "input",
      function (e) {
        var t = e.target;
        if (!t || t.name !== "q") return;
        clearTimeout(timer);
        timer = setTimeout(apply, 100);
      },
      true
    );
  }

  async function enhanceSearchPage() {
    if (!/\/search\/?$/.test(window.location.pathname)) return;
    var q = getQueryFromLocation();
    if (!q) return;
    if (/^vendor:/i.test(q)) {
      // vendor: aramasında da gevşek kart olursa ölçü filtresi yok; bırak
      return;
    }

    var products = [];
    try {
      products = await fetchSuggest(q);
    } catch (e) {
      return;
    }

    var vendor = shouldUseVendorSearch(q, products);
    if (vendor) {
      var url = new URL(window.location.href);
      url.searchParams.set("q", "vendor:" + vendor);
      url.searchParams.set("type", "product");
      if (url.toString() !== window.location.href) {
        window.location.replace(url.toString());
        return;
      }
    }

    var allowedIds = new Set(products.map(productId).filter(Boolean));
    var grid =
      document.querySelector("results-list") ||
      document.querySelector(".product-grid") ||
      document.querySelector("[data-testid='results-list']") ||
      document.querySelector("main");

    // Kritik token varsa / suggest varsa: sayfa sonuçlarını sıkı filtrele
    var tokens = tokenize(q);
    var crit = criticalTokens(tokens);
    if (crit.length || products.length) {
      filterDomCards(grid, q, products.length ? allowedIds : null);
    }

    var target =
      document.querySelector("results-list [ref='grid']") ||
      document.querySelector("results-list ul") ||
      document.querySelector(".product-grid") ||
      grid;

    if (!target || !products.length) return;

    var have = new Set();
    target.querySelectorAll("[data-product-id]").forEach(function (el) {
      var row = el.closest("li") || el;
      if (row.style.display === "none" || row.hidden) return;
      if (row.getAttribute("data-gordonix-filtered") === "1") return;
      have.add(String(el.getAttribute("data-product-id")));
    });

    // Gevşek arama çok sonuç getirdiyse: sadece suggest eşleşenleri bırak + eksikleri ekle
    if (crit.length || isBrandOnlyQuery(q)) {
      var empty = document.querySelector(
        ".search-empty, [data-testid='search-empty'], .results-list--empty"
      );
      if (empty && products.length) empty.style.display = "none";
      appendSuggestCards(target, products, have);
    } else if (have.size < Math.min(6, products.length)) {
      appendSuggestCards(target, products, have);
    }
  }

  function interceptForms() {
    document.addEventListener(
      "submit",
      function (e) {
        var form = e.target;
        if (!(form instanceof HTMLFormElement)) return;
        if (!form.action || form.action.indexOf("/search") === -1) return;
        var input =
          form.querySelector('input[name="q"]') ||
          form.querySelector('input[type="search"]');
        if (!input) return;
        var q = (input.value || "").trim();
        if (!q || /^vendor:/i.test(q)) return;

        e.preventDefault();
        fetchSuggest(q)
          .then(function (products) {
            var vendor = shouldUseVendorSearch(q, products);
            var typeInput = form.querySelector('input[name="type"]');
            if (!typeInput) {
              typeInput = document.createElement("input");
              typeInput.type = "hidden";
              typeInput.name = "type";
              form.appendChild(typeInput);
            }
            typeInput.value = "product";
            input.value = vendor ? "vendor:" + vendor : q;
            HTMLFormElement.prototype.submit.call(form);
          })
          .catch(function () {
            HTMLFormElement.prototype.submit.call(form);
          });
      },
      true
    );
  }

  interceptForms();
  watchPredictive();
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", enhanceSearchPage);
  } else {
    enhanceSearchPage();
  }
})();
